<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.99791"
      y="7.00793"
      width="14.0058"
      height="14.0058"
      rx="2"
      stroke="currentColor"
      fill="none"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.99791 17.0121H4.99708C3.89205 17.0121 2.99625 16.1163 2.99625 15.0113V5.00709C2.99625 3.90206 3.89205 3.00626 4.99708 3.00626H15.0012C16.1063 3.00626 17.0021 3.90206 17.0021 5.00709V7.00792"
      stroke="currentColor"
      fill="none"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
